<template>
  <div class="flex1">
    <div class="row" v-if="parameterError">
      <div class="col-12">
        <div class="alert alert-danger" id="parameterError">
          {{ parameterError }}
        </div>
      </div>
    </div>
    
    <div class="row"> 
      <div class="col-12">
          <InfoBox :title="'Parameters'" :description="paramsInfo"/>
      </div>
    </div>
    <div class="text-right ml-auto">
      <input class="searchInput" style="text-align: center;" type="text" id="filterInput" placeholder="Please choose a tag" v-model="searchFilter" list="tags">
      <datalist style="background-color: blue" id="tags">
        <option  v-for="tag in tags" :key="tag" :value="tag">{{tag}}</option>
      </datalist>
      <div class="btn-group " role="group" aria-label="Basic example" >
          <button
            type="button"
            :class="`btn btn-sm ${filterBtnColors['ios']}`"
            @click="toggleFilter('ios')"
            style="padding: 5px 10px; "
          >
            iOS
          </button>
          <button
            type="button"
            :class="`btn btn-sm ${filterBtnColors['android']}`"
            @click="toggleFilter('android')"
            style="padding: 5px 10px;"
          >
            Android
          </button>
        </div>
        <div>
          <button
            type="button"
            :class="`btn btn-sm ${filterBtnColors['hide']}`"
            @click="toggleHideFilter()"
            style="padding: 7px 7px; margin-left: 1em; "
          >
          Hiddens
          </button>
      </div>
    </div>
    <div class="row titles">
      <div class="col-md-2 col-12 my-auto">Status</div>
      <div
        class="col-md-2 col-12 my-auto"
        @click="changeSortParams('key')"
        style="cursor: pointer"
      >
        {{
          "Parameter Key  " +
          (sortParams.field === "key"
            ? sortParams.direction === "ASC"
              ? "&#8595;"
              : "&#8593;"
            : "")
        }}
      </div>
      <div class="col-md-3 col-12 my-auto">Description</div>
      <div
        class="col-md-2 col-12 my-auto"
        @click="changeSortParams('created_at')"
        style="cursor: pointer"
      >
        {{
          "Create Date  " +
          (sortParams.field === "created_at"
            ? sortParams.direction === "ASC"
              ? "&#8595;"
              : "&#8593;"
            : "")
        }}
      </div>
      <div class="col-md-1 col-12 platform-padding my-auto">Platform</div>
      <div class="col-md-2 col-12 platforms">
      </div>
    </div>
      <div class="row">
      <div class="col-md-2 col-12"/>
      <div class="col-md-2 col-12">
        
        <input
          class="form-control"
          type="text"
          v-model="newParameter.key"
          placeholder="New Parameter"
        />
     
      </div>
      <div class="col-md-3 col-12" style="position: relative;"> 
        <div style="position: relative; ">
        <textarea
          class="form-control opening-input"
          type="text"
          v-model="newParameter.desc"
          placeholder="New Description"
        />
      </div>
      </div>
      <div class="col-md-2 col-12"/>
      <div class="col-md-1 col-12 center-para">
        <select v-model="newParameter.os">
          <option :value="['ios']">IOS</option>
          <option :value="['android']">Android</option>
          <option :value="['ios', 'android']">Both</option>
          <option :value="['web']">Web</option>
          <option :value="['w2a']">W2A</option>
          <option :value="['backend']">Backend</option>
          <option :value="['ios', 'android', 'web', 'w2a', 'backend']">All</option>
        </select>
      </div>
      <div class="col-md-2 col-12 text-center">
        <button class="btn btn-sm btn-success mx-2" @click="addNewParameter()">
          ADD
        </button>
      </div>
    </div>
    <hr class="dashed">
    <template v-for="(parameter, index) in displayParameters">
    <div v-if="parameter.isHeader" :key="'header-'+index" class="row titles">
        <div class="col-12">Favorites</div>
    </div>
    <div v-else-if="parameter.isSeparator" :key="'sep-'+index" class="row">
        <div class="col-12"><hr class="dashed"></div>
    </div>
    <div
      v-else
      class="row line-hover"
      :key="`parameter-${parameter.key}-${parameter.id}`"
      @click="navigateToParameter(parameter.id, $event)"
      style="cursor: pointer;"
    >
      <div class="col-md-2 col-12 center-para" style="padding: 0px;" v-on:click="stopPropagation">
        <button
          type="button"
          class="btn btn-sm status-button"
          style="padding: 5px 10px;"
          @click="toggleFavorite(parameter.id)"
        >
          <i class="tim-icons icon-heart-2" :class="isFavorite(parameter.id) ? 'text-danger' : 'text-white'"></i>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-success status-button fa fa-eye icon"
          v-if="!parameter.is_hidden"
          @click="hideParameter(parameter.id)"
        >
        
        </button>
        <button
          type="button"
          class="btn btn-sm status-button fa fa-eye-slash icon"
          v-if="parameter.is_hidden"
          @click="hideParameter(parameter.id)"
        >
          
        </button>
        <button
          class="btn btn-sm btn-success status-button"
          style="width: 40%;"
          v-if="parameter.is_active != false"
          @click="keyActivation(parameter.id, 'deactivate')"
        >
          Active
        </button>
        <button
          class="btn btn-sm status-button "
          style="width: 40%;"
          v-else
          @click="keyActivation(parameter.id, 'activate')"
        >
          Passive
        </button>
      </div>
      <div class="col-md-2 col-12 center-para">
          {{ parameter.key }}
      </div>
      <div class="col-md-3 col-12 center-para">
        <input
          v-if="isEditing(parameter.id)"
          :id="`edit-param-${parameter.id}`"
          :value="parameter.desc"
          class="form-control"
          type="text"
          placeholder="Description"
          v-on:click="stopPropagation"
        />
        <span v-else>
          {{ parameter.desc }}
        </span>
      </div>
      <div class="col-md-2 col-12 center-para">
        {{ dateFormatter(parameter.created_at) }}
      </div>
      <div class="col-md-1 col-12 center-para" v-on:click="stopPropagation">
        <select 
          v-if="
            parameters.filter((item) => parameter.key == item.key).length > 1
          "
          disabled="disabled"
          v-model="parameter.os"
          @input="(e) => editParameter(parameter.id, e.target.value.split(','))"
        >
          <option :value="undefined" disabled>Both</option>
          <option :value="['ios']">IOS</option>
          <option :value="['android']">Android</option>
          <option :value="['ios', 'android']">Both</option>
          <option :value="['web']">Web</option>
          <option :value="['w2a']">W2A</option>
          <option :value="['backend']">Backend</option>
          <option :value="['ios', 'android', 'web', 'w2a', 'backend']">All</option>
        </select>
        <select
          v-else
          v-model="parameter.os"
          @input="(e) => editParameter(parameter.id, e.target.value.split(','))"
        >
          <option :value="undefined" disabled>IOS</option>
          <option :value="['ios']">IOS</option>
          <option :value="['android']">Android</option>
          <option :value="['ios', 'android']">Both</option>
          <option :value="['web']">Web</option>
          <option :value="['w2a']">W2A</option>
          <option :value="['backend']">Backend</option>
          <option :value="['ios', 'android', 'web', 'w2a', 'backend']">All</option>
        </select>
      </div>
      <div class="col-md-2 col-12 action-buttons-div center-para" style="text-align: center;" v-on:click="stopPropagation">
        <button
          class="btn btn-sm btn-danger mx-2 action-button"
          @click="deleteParameter(parameter.id);" 
        >
          Del
        </button>
      </div>
    </div>
    </template>

  </div>
</template>

<script>
import axios from "axios";
import formatters from "../util/formatters";
import InfoBox from "../components/common/InfoBox.vue";
import info from "../constants/info.js"
export default {
  components: {
    InfoBox
  },
  data() {
    return {
      favorites: [],
      newParameter: {
        os: ["ios","android"],
      },
      paramsInfo : info.parameters.default,
      editList: [],
      iosFilter: true,
      androidFilter: true,
      showHiddenFilter: false,
      parameterError: undefined,
      sortParams: {
        field: "created_at",
        direction: "DESC",
      },
      dateFormatter: formatters.dateFormatter,
      searchFilter:'',
      tags : []
    };
  },
  created() {
    this.loadFavorites();
  },
  computed: {
    displayParameters() {
      const favs = [];
      const others = [];
      this.filteredParameters.forEach(p => {
          if (this.isFavorite(p.id)) favs.push(p);
          else others.push(p);
      });
      
      if (favs.length === 0) return others;
      
      const list = [{ isHeader: true, title: 'Favorites' }, ...favs];
      if (others.length > 0) list.push({ isSeparator: true }, ...others);
      return list;
    },
    parameters() {
      let parameters = this.$store.getters.parameters.sort(this.sorter);
      parameters.forEach(parameter => {
        if(parameter.tag){
          if(!this.tags.includes(parameter.tag))this.tags.push(parameter.tag)
        } 
      })
      return parameters;
    },
    filteredParameters() {
      const parameters = this.showHiddenFilter
        ? this.parameters
        : this.parameters.filter((item) => !item.is_hidden);
      
      const tagFilteredParams = parameters.filter((parameter)=> {
        if (parameter.tag){
          return parameter.tag.toUpperCase().includes(this.searchFilter.toUpperCase()) ||
          parameter.key.toUpperCase().includes(this.searchFilter.toUpperCase())
        }
        return parameter.key.toUpperCase().includes(this.searchFilter.toUpperCase())
      })
      if (this.iosFilter && this.androidFilter) {
        return tagFilteredParams;
      } else if (!this.iosFilter && !this.androidFilter) {
        return [];
      } else if (this.iosFilter) {
        return parameters.filter(
          (item) => item.os == undefined || item.os.indexOf("ios") >= 0
        );
      } else if (this.androidFilter) {
        return parameters.filter(
          (item) => item.os != undefined && item.os.indexOf("android") >= 0
        );
      }
    },
    filterBtnColors() {
      return {
        ios: this.iosFilter ? "btn-success" : "btn-secondary",
        android: this.androidFilter ? "btn-success" : "btn-secondary",
        hide: this.showHiddenFilter ? "btn-success" : "btn-secondary",
      };
    },
  },
  methods: {
    navigateToParameter(id, event) {
      const route = this.$router.resolve({ name: 'Parameter', params: { id } });
      
      // Check if user wants to open in new tab
      if (event.ctrlKey || event.metaKey || event.button === 1) {
        // Ctrl+Click, Cmd+Click (Mac), or Middle mouse button
        window.open(route.href, '_blank');
      } else {
        // Normal click - navigate in same tab
        this.$router.push({ name: 'Parameter', params: { id } });
      }
    },
    loadFavorites() {
      try {
        const stored = localStorage.getItem('favoriteParameters');
        const allFavorites = stored ? JSON.parse(stored) : {};
        this.favorites = allFavorites[this.$route.params.aid] || [];
      } catch (error) {
        console.error('Error loading favorites:', error);
        this.favorites = [];
      }
    },
    saveFavorites() {
      try {
        const stored = localStorage.getItem('favoriteParameters');
        const allFavorites = stored ? JSON.parse(stored) : {};
        allFavorites[this.$route.params.aid] = this.favorites;
        localStorage.setItem('favoriteParameters', JSON.stringify(allFavorites));
      } catch (error) {
        console.error('Error saving favorites:', error);
      }
    },
    toggleFavorite(id) {
      const index = this.favorites.indexOf(id);
      if (index === -1) {
        this.favorites.push(id);
      } else {
        this.favorites.splice(index, 1);
      }
      this.saveFavorites();
    },
    isFavorite(id) {
      return this.favorites.includes(id);
    },
    stopPropagation(event){
      event.stopPropagation();
    },
    async addNewParameter() {
      this.parameterError = "";
      let restrictedKeys;
      if (this.newParameter.os && this.newParameter.os.length > 1) {
        restrictedKeys = this.parameters.map((item) => item.key);
      } else {
        restrictedKeys = this.parameters
          .filter((item) => {
            if (item.os == undefined) {
              return (
                this.newParameter.os == undefined ||
                this.newParameter.os.indexOf("ios") >= 0
              );
            } else {
              return item.os.indexOf(this.newParameter.os[0]) >= 0;
            }
          })
          .map((item) => item.key);
      }
      restrictedKeys.push("isl_keys");
      restrictedKeys.push("passive_experiments");
      restrictedKeys.push("considered_for_experiment");
      restrictedKeys.push("_variant_name");
      restrictedKeys.push("_country")
      restrictedKeys.push("_region")
      restrictedKeys.push("_city")
      if (
        this.newParameter.key &&
        restrictedKeys.indexOf(this.newParameter.key) < 0 &&
        this.newParameter.desc
      ) {
        this.newParameter.key = this.newParameter.key.trim();
        this.newParameter.created_at = new Date() * 1;
        this.newParameter.is_hidden = false;
        const parameter = await this.$store.dispatch("configAdd", {
          type: "parameter",
          payload: this.newParameter,
        });
        const id = parameter.data.result
        this.$router.push({ name: 'Parameter', params: { id: id} })
        this.newParameter = {};
      } else {
        this.parameterError =
          "A field is missing or parameter key is not available";
        document.scrollTop();
      }
    },
    deleteParameter(id) {
      if (
        confirm(
          `You are trying to delete "${
            this.parameters.find((item) => item.id == id).key
          }" parameter. Are you sure?`
        )
      ) {
        this.$store.dispatch("configDelete", {
          type: "parameter",
          payload: id,
        });
      }
    },
    hideParameter(id) {
      const parameter = this.parameters.find((el) => el.id == id);
      if (!("is_hidden" in parameter)) {
        parameter.is_hidden = false;
      }
      parameter.is_hidden = !parameter.is_hidden;
      const data = JSON.parse(JSON.stringify(parameter));
      delete data.id;
      this.$store.dispatch("configEdit", {
        type: "parameter",
        payload: { id, data },
      });
      this.editList = this.editList.filter((item) => item != id);
    },
    activateEdit(id) {
      this.editList.push(id);
    },
    keyActivation(keyId, operation) {
      this.$store.dispatch("activationOp", {
        type: "parameter",
        operation: { [operation]: [keyId] },
      });
    },
    isEditing(id) {
      return this.editList.indexOf(id) >= 0;
    },
    editParameter(id, os) {
      const parameter = this.parameters.find((el) => el.id == id);
      const data = JSON.parse(JSON.stringify(parameter));
      delete data.id;
      if (os) {
        if (
          this.parameters.filter((item) => item.key == parameter.key).length > 1
        ) {
          this.parameterError =
            "Can't change the os since there is another parameter with the same name";
          document.scrollTop();
          return;
        }
        data.os = os;
      } else {
        data.desc = document.getElementById("edit-param-" + id).value;
      }
      this.$store.dispatch("configEdit", {
        type: "parameter",
        payload: { id, data },
      });
      this.editList = this.editList.filter((item) => item != id);
    },
    changeSortParams(field) {
      if (this.sortParams.field === field) {
        this.sortParams.direction =
          this.sortParams.direction === "ASC" ? "DESC" : "ASC";
      } else {
        this.sortParams = { field, direction: "ASC" };
      }
    },
    sorter(a, b) {
      const aField = a[this.sortParams.field] || 0;
      const bField = b[this.sortParams.field] || 0;
      if (typeof aField === "string" && typeof bField === "string") {
        if (aField.toUpperCase() < bField.toUpperCase())
          return this.sortParams.direction === "ASC" ? -1 : 1;
        if (aField.toUpperCase() > bField.toUpperCase())
          return this.sortParams.direction === "ASC" ? 1 : -1;
        return 0;
      }
      if (aField < bField) return this.sortParams.direction === "ASC" ? -1 : 1;
      if (aField > bField) return this.sortParams.direction === "ASC" ? 1 : -1;
      return 0;
    },
    toggleFilter(type) {
      if (type == "ios") {
        this.iosFilter = !this.iosFilter;
      } else {
        this.androidFilter = !this.androidFilter;
      }
    },
    toggleHideFilter() {
      this.showHiddenFilter = !this.showHiddenFilter;
    },
  },
};
</script>

<style lang="scss" scoped>
@import  "../components/common/styles/form_elements.scss";
</style>
<style scoped>

.flex1 {
  color: rgba(255, 255, 255, 0.8);
}
.row {
  margin: 5px 0;
}
.row div {
  word-wrap: break-word;
}

.action-buttons-div{
  margin-right: 0px;
}

.status-button{
  margin-left: 7px;
  padding: 5px 10px;
}
.platform-padding{
  padding: 0px 0px;
}
.platforms{
  margin:0px; 
  text-align: center; 
  justify-content: center; 
  display: block; 
  top: -10px;
}

.icon{
  width: 25%;
  justify-content: center; 
  align-items: center;
}

.searchInput{
  width: 13em;
  margin-right: 5px;
  border-radius: 6px;
  border-color: white;
  color: white;
  background-color: inherit;
}

.titles {
  color: #778ca3;
  font-size: 24px;
  line-height: 50px;
}

</style>
